"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrimOnPasteDirective = void 0;
const core_1 = require("@angular/core");
/**
   * Trim on paste Directive
   *
   */
class TrimOnPasteDirective {
    constructor(el) {
        this.el = el;
    }
    onPaste(event) {
        const pastedInput = event.clipboardData.getData('text/plain');
        event.preventDefault();
        document.execCommand('insertText', false, pastedInput.trim());
    }
}
exports.TrimOnPasteDirective = TrimOnPasteDirective;
//# sourceMappingURL=trimonpaste.directive.js.map